export const Header = {
    methods: {
        deleteAll() {
            this.$store.dispatch('deleteItems')
        }
    },
    // language=Vue
    template: `
        <div class="page-header">
            <div class="page-header__top">
                <div class="back-link">
                    <a href="/catalog/" class="back-link__item svg-icon hover">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.2178 1.93262L17.0742 2.86816L17.1357 2.93555L17.0742 3.00391L8.84766 12L17.0742 20.9961L17.1357 21.0645L17.0742 21.1318L16.2178 22.0674L16.1445 22.1484L16.0703 22.0674L7.78223 13.0039L6.92676 12.0684L6.86426 12.001L6.92676 11.9336L7.78223 10.9971L16.0703 1.93262L16.1445 1.85156L16.2178 1.93262Z"
                                fill="black" stroke="black" stroke-width="0.2"/>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="page-header__bottom">
                <h1 class="page-header__title title-big">{{this.$Bitrix.Loc.getMessage('SALE_BASKET_TITLE')}}</h1>
                <div class="basket-actions">
                    <div class="basket-actions__item cart_sharing hover">
                        <div class="svg-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
                                <path d="M17 8L12 3L7 8" stroke="black" stroke-width="1.5"/>
                                <path d="M12 16V4" stroke="black" stroke-width="1.5"/>
                                <path d="M4 14V21H20V14" stroke="black" stroke-width="1.5"/>
                            </svg>
                        </div>
                        {{this.$Bitrix.Loc.getMessage('SALE_BASKET_SHARED')}}
                    </div>
                    <div class="basket-actions__item hover" @click="deleteAll">
                        <div class="svg-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
                                <path
                                    d="M5.59995 21.6004H4.84995V22.3504H5.59995V21.6004ZM18.4 21.6004V22.3504H19.15V21.6004H18.4ZM8.79995 2.40039V1.65039C8.60104 1.65039 8.41027 1.72941 8.26962 1.87006C8.12897 2.01071 8.04995 2.20148 8.04995 2.40039H8.79995ZM15.2 2.40039H15.95C15.95 2.20148 15.8709 2.01071 15.7303 1.87006C15.5896 1.72941 15.3989 1.65039 15.2 1.65039V2.40039ZM4.84995 5.60039V21.6004H6.34995V5.60039H4.84995ZM5.59995 22.3504H18.4V20.8504H5.59995V22.3504ZM19.15 21.6004V5.60039H17.65V21.6004H19.15ZM9.54995 5.60039V2.40039H8.04995V5.60039H9.54995ZM8.79995 3.15039H15.2V1.65039H8.79995V3.15039ZM14.45 2.40039V5.60039H15.95V2.40039H14.45ZM20.7999 4.85039H3.19995V6.35039H20.7999V4.85039Z"
                                    fill="black"/>
                                <path d="M12 9.59766V17.3977V9.59766Z" fill="black"/>
                                <path d="M12 9.59766V17.3977" stroke="black" stroke-width="1.5"/>
                                <path d="M15 9.59766V17.3977V9.59766Z" fill="black"/>
                                <path d="M15 9.59766V17.3977" stroke="black" stroke-width="1.5"/>
                                <path d="M9 9.59766V17.3977V9.59766Z" fill="black"/>
                                <path d="M9 9.59766V17.3977" stroke="black" stroke-width="1.5"/>
                            </svg>
                        </div>
                        {{this.$Bitrix.Loc.getMessage('SALE_BASKET_CLEAR_ALL')}}
                    </div>
                </div>
            </div>
        </div>
    `
}

export const Footer = {
    computed: {
        total() {
            return this.$store.state.total
        },
        authorized() {
            return this.$store.state.authorized
        },
        coupons: {
            get() {
                return this.$store.state.coupons
            }
        },
        siteId() {
            return this.$Bitrix.Application.instance.siteId
        },
        loc() {
            return this.$Bitrix.Loc
        },
        coupon: {
            get() {
                return this.$store.state.coupon
            },
            set(value) {
                this.$store.commit('setCoupon', value)
            }
        },
    },
    methods: {
        sendCoupon() {
            this.$store.dispatch('sendCoupon')
        },
        deleteCoupon(coupon) {
            this.$store.dispatch('deleteCoupon', coupon)
        }
    },
    // language=Vue
    template: `
        <div class="basket-total-block">
            <div class="basket-checkout-container">
                <div class="purchase">
                    <div class="purchase-coupons">
                        <template v-if="coupons.length > 0">
                            <div class="purchase-coupons__list">
                                <div class="coupons-list">
                                    <div v-for="coupon in coupons" class="coupons-list__item">
                                        <div class="coupon-text">
                                            <strong>{{coupon.COUPON}}</strong> - {{coupon.JS_CHECK_CODE}}
                                            <span v-if="coupon.DISCOUNT_NAME">{{coupon.DISCOUNT_NAME}}</span>
                                        </div>
                                        <div class="coupon-delete underlined hover" @click="event => deleteCoupon(coupon.COUPON)">{{loc.getMessage('SBB_DELETE')}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="purchase-coupons__field">
                            <div class="coupons-field">
                                <input type="text" class="coupons-field__input"
                                   :placeholder="loc.getMessage('SBB_COUPON_ENTER')" v-model="coupon">
                                <button class="coupons-field__btn" value="Найти"  @click="sendCoupon" v-if="coupon.length > 0">
                                    <span class="svg-icon">
                                         <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                              viewBox="0 0 25 25" fill="none">
                                              <circle cx="12.5" cy="12.5" r="12.5" fill="#D9D9D9"/>
                                              <path
                                                  d="M18.3536 12.3536C18.5488 12.1583 18.5488 11.8417 18.3536 11.6464L15.1716 8.46447C14.9763 8.2692 14.6597 8.2692 14.4645 8.46447C14.2692 8.65973 14.2692 8.97631 14.4645 9.17157L17.2929 12L14.4645 14.8284C14.2692 15.0237 14.2692 15.3403 14.4645 15.5355C14.6597 15.7308 14.9763 15.7308 15.1716 15.5355L18.3536 12.3536ZM7 12V12.5L18 12.5V12V11.5L7 11.5V12Z"
                                                  fill="white"/>
                                        </svg>
                                     </span>
                                </button>
                            </div>
                        </div>
                         <div v-if="!authorized" class="purchase-coupons__auth">
                            <div class="purchase-coupons__auth">
                                <div class="purchase-auth">
                                    <div class="purchase-auth__title" v-html="loc.getMessage('SALE_BASKET_AUTH')"></div>
                                    <div class="ibutton wide js-open-auth">{{loc.getMessage('SBB_LOGIN')}}</div>
                                </div>
                            </div>
                         </div>
                    </div>
                    <div class="purchase-total">
                        <div class="purchase-total__delivery" v-if="siteId === 's1'">
                            <div class="delivery-status">
                                <div class="delivery-status__progress">
                                    <div class="delivery-status__progress-bar"
                                         :style="{'width': total.DELIVERY_PROGRESS_PERCENT + '%'}"></div>
                                </div>
                                <div class="delivery-status__desc">
                                    <template v-if="total.DELIVERY_IS_FREE === true">{{loc.getMessage('SALE_BASKET_DISCOUNT_DELIVERY_FULL')}}</template>
                                    <template v-if="total.DELIVERY_IS_FREE === false">
                                        {{loc.getMessage('SALE_BASKET_DISCOUNT_DELIVERY')}}
                                        <span class="js-delivery-remains">{{total.DELIVERY_REMAINS_FORMATTED}}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="purchase-total__table">
                            <div class="purchase-table">
                                <div class="purchase-table__item">
                                    <div class="name">{{loc.getMessage('SALE_BASKET_TOTAL_PRICE')}}</div>
                                    <div class="val">{{total.PRICE_WITHOUT_DISCOUNT_FORMATED}}</div>
                                </div>
                                <div class="purchase-table__item">
                                    <div class="name">{{loc.getMessage('SALE_BASKET_TOTAL_DISCOUNT_PRICE')}}</div>
                                    <div class="val" data-entity="basket-total-price">{{total.PRICE_FORMATED}}</div>
                                </div>
                                <div class="purchase-table__item">
                                    <div class="name">{{loc.getMessage('SALE_BASKET_ESTIMATED_DELIVERY_PRICE')}}</div>
                                    <div class="val">{{total.FULL_PRICE_DELIVERY_FORMATED}}</div>
                                </div>
                                <div class="purchase-table__item purchase-table__item--total">
                                    <div class="name">{{loc.getMessage('SALE_BASKET_TOTAL')}}</div>
                                    <div class="val" data-entity="basket-total-price-f">{{total.FULL_PRICE_FORMATED}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="purchase-total__credit" v-if="siteId === 's1'">
                            <div class="credit-button js-open-credit">
                                <div class="credit-button__text">
                                    <span>Раздели на&nbsp;4&nbsp;платежа по&nbsp;</span>
                                    <span class="js-credit-price">{{total.FULL_PRICE_CREDIT}}</span>
                                </div>
                                <div class="svg-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M12.5 8L6.65782 2L5.31564 3.42335L9.81564 8L5.31564 12.5766L6.65782 14L12.5 8Z"
                                              fill="#C7C9CC"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div v-if="total.DISABLE_CHECKOUT === false" class="purchase-total__button">
                            <a href="/order/" class="ibutton js-metrika-order-start">{{loc.getMessage('SBB_ORDER')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
}

export const Item = {
    props: ['item'],
    computed: {
        siteId() {
            return this.$Bitrix.Application.instance.siteId
        },
        loc() {
            return this.$Bitrix.Loc
        },
        ajaxPath() {
            return this.$Bitrix.Application.instance.ajaxPath
        },
        signedTemplate() {
            return this.$Bitrix.Application.instance.signedTemplate
        },
        signedParameters() {
            return this.$Bitrix.Application.instance.signedParameters
        }
    },
   methods: {
        delay(event) {
            let data = {}, key = 'basket[DELAY_' + this.item.ID + ']'

            data[key] = event.target.checked ? 'N' : 'Y'
            this.$store.dispatch('sendRequest', data)
        },
        changeQuantity(direction) {
            let data = {}, key = 'basket[QUANTITY_' + this.item.ID + ']'
            data[key] = direction === 'up' ? this.item.QUANTITY + 1 : this.item.QUANTITY - 1

            this.$store.dispatch('sendRequest', data)
        },
        deleteItem() {
            let data = {}, key = 'basket[DELETE_' + this.item.ID + ']'
            data[key] = 'Y'

            this.$store.dispatch('sendRequest', data)
        }
    },
    // language=Vue
    template: `
      <tr :class="{'basket-list__item': true, 'basket-items-list-item-container': true, 'not_available': item.NOT_AVAILABLE}">
        <td class="checkbox">
          <div class="form-checkbox">
            <input class="form-checkbox__input" :id="'basket-item-check-' + item.ID" type="checkbox"
                   v-model="item.CHECKED" @change="delay"/>
            <label class="form-checkbox__label" :for="'basket-item-check-' + item.ID">
              <span class="form-checkbox__box"></span>
            </label>
          </div>
        </td>
        <td class="image">
          <div class="image-element img-rel">
            <a :href="item.DETAIL_PAGE_URL" target="_blank">
              <img :src="item.IMAGE_URL" :alt="item.NAME"/>
            </a>
          </div>
        </td>
        <td class="desc">
          <div class="desc-info">
            <div class="desc-info__top">
              <div class="desc-info__top-top">
                <template v-for="property in item.PROPS">
                  <div v-if="property.CODE === 'BRAND'" class="brand">{{property.VALUE}}</div>
                </template>
                <template v-for="property in item.PROPS">
                  <div v-if="property.CODE === 'CML2_ARTICLE'" class="article">
                    {{loc.getMessage('SALE_BASKET_ARTICLE')}}{{property.VALUE}}
                  </div>
                </template>
              </div>
              <div v-if="item.IS_FBS" class="article article--fbs">Склад FBS</div>
            </div>
            <a class="desc-info__title hover" target="_blank" :href="item.DETAIL_PAGE_URL">{{item.NAME}}</a>
          </div>
          <div class="desc-properties">
            <template v-for="property in item.PROPS_ALL">
              <div v-if="property.IS_PROPERTY_SIZES_VALUE === true" class="desc-properties__item">
                <div class="name" data-entity="basket-item-property">{{property.NAME}}:</div>
                <div v-if="property.IS_PREORDER_PRODUCT_VALUE" class="val" :data-column-property-code="property.CODE"
                     data-entity="basket-item-property-column-value">
                  {{property.VALUE}}
                  <div v-if="property.SHOW_LAST_SIZE" class="size-last">[{{loc.getMessage('SALE_BASKET_LAST_SIZE')}}]
                  </div>
                </div>
              </div>
              <div v-if="property.IS_SHOW_LEFT">
                <div class="desc-properties__item">
                  <div class="name" data-entity="basket-item-property">{{property.NAME}}:</div>
                  <div v-if="property.IS_PREORDER_PRODUCT_VALUE" class="val" :data-column-property-code="property.CODE"
                       data-entity="basket-item-property-column-value">
                    {{property.VALUE}}
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="desc-mobile"></div>
        </td>
        <td class="summa">
          <div class="summa-price">
            <div class="price-current">{{item.PRICE_FORMATED}}</div>
            <div v-if="item.SHOW_OLD_PRICE" class="summa-price__bottom">
              <div class="price-percent">-{{item.DISCOUNT_PERCENT}}%</div>
              <div class="price-old">{{item.OLD_PRICE_FORMATED}}</div>
            </div>
          </div>
          <div v-if="siteId === 's1'" class="credit-button js-open-credit">
            <div class="credit-button__text">
              4&nbsp;платежа по&nbsp;<span class="js-credit-price">{{item.PRICE_CREDIT}}</span>
            </div>
            <div class="svg-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12.5 8L6.65782 2L5.31564 3.42335L9.81564 8L5.31564 12.5766L6.65782 14L12.5 8Z"
                      fill="#C7C9CC"></path>
              </svg>
            </div>
          </div>
        </td>
        <td class="count">
          <div v-if="item.NO_GIFT" class="quantity-button">
            <div class="quantity-button__btn quantity-button__btn--minus" @click="() => changeQuantity('down')"></div>
            <input class="quantity-button__field" type="text" :value="item.QUANTITY" readonly/>
            <div class="quantity-button__btn quantity-button__btn--plus" @click="() => changeQuantity('up')"></div>
          </div>
        </td>
        <td class="control">
          <div class="control-actions">
            <div class="basket-oneclick-wrapper"
                 :data-result='item.ONE_CLICK'>
              <div class="control-buy ibutton oneclick-desktop">{{loc.getMessage('SALE_BASKET_BUY')}}</div>
            </div>
            <div class="control-buttons">
              <div class="control-favorite control-buttons__item svg-icon hover js-favorite-button" :data-id="item.PRODUCT_PARENT_ID">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none">
                  <path
                      d="M9.42211 4.41431L10 5.11285L10.5779 4.41431C11.4241 3.39141 12.7193 2.75 14.05 2.75C16.3875 2.75 18.25 4.63556 18.25 7.09537C18.25 8.60696 17.5962 10.0335 16.3034 11.6605C15.0015 13.299 13.1255 15.0519 10.7932 17.2288L10.7922 17.2298L9.99805 17.974L9.20735 17.2387C9.2071 17.2384 9.20685 17.2382 9.2066 17.238C6.87454 15.0565 4.99871 13.3015 3.69673 11.6618C2.40382 10.0336 1.75 8.60697 1.75 7.09537C1.75 4.63556 3.61253 2.75 5.95 2.75C7.28068 2.75 8.5759 3.39141 9.42211 4.41431Z"
                      stroke="#000000" stroke-width="1.5"></path>
                </svg>
              </div>

              <div class="control-remove control-buttons__item svg-icon hover" @click="deleteItem">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                     viewBox="0 0 24 24" fill="none">
                  <path
                      d="M5.59995 21.6004H4.84995V22.3504H5.59995V21.6004ZM18.4 21.6004V22.3504H19.15V21.6004H18.4ZM8.79995 2.40039V1.65039C8.60104 1.65039 8.41027 1.72941 8.26962 1.87006C8.12897 2.01071 8.04995 2.20148 8.04995 2.40039H8.79995ZM15.2 2.40039H15.95C15.95 2.20148 15.8709 2.01071 15.7303 1.87006C15.5896 1.72941 15.3989 1.65039 15.2 1.65039V2.40039ZM4.84995 5.60039V21.6004H6.34995V5.60039H4.84995ZM5.59995 22.3504H18.4V20.8504H5.59995V22.3504ZM19.15 21.6004V5.60039H17.65V21.6004H19.15ZM9.54995 5.60039V2.40039H8.04995V5.60039H9.54995ZM8.79995 3.15039H15.2V1.65039H8.79995V3.15039ZM14.45 2.40039V5.60039H15.95V2.40039H14.45ZM20.7999 4.85039H3.19995V6.35039H20.7999V4.85039Z"
                      fill="black"/>
                  <path d="M12 9.59766V17.3977V9.59766Z" fill="black"/>
                  <path d="M12 9.59766V17.3977" stroke="black" stroke-width="1.5"/>
                  <path d="M15 9.59766V17.3977V9.59766Z" fill="black"/>
                  <path d="M15 9.59766V17.3977" stroke="black" stroke-width="1.5"/>
                  <path d="M9 9.59766V17.3977V9.59766Z" fill="black"/>
                  <path d="M9 9.59766V17.3977" stroke="black" stroke-width="1.5"/>
                </svg>
              </div>
            </div>
          </div>
        </td>
        <div v-if="item.NOT_AVAILABLE" class="control-alert basket-items-list-item-warning-container">
          <div class="alert alert-warning text-center">{{loc.getMessage('SBB_BASKET_ITEM_NOT_AVAILABLE')}}</div>
        </div>
      </tr>
    `
}

export const Items = {
    computed: {
        items() {
            return this.$store.state.items
        },
        total() {
            return this.$store.state.total
        },
        siteId() {
            return this.$Bitrix.Application.instance.siteId
        },
        allChecked() {
            return this.items.filter(item => item.CHECKED === false).length === 0
        },
        loc() {
            return this.$Bitrix.Loc
        }
    },
    components: {Item},
    methods: {
        checkAll(event) {
            this.$store.dispatch('toggleItems', event.target.checked)
        },
        deleteChecked() {
            this.$store.dispatch('deleteCheckedItems')
        }
    },
    mounted() {
        //console.log(this.allChecked)
    },
    // language=Vue
    template: `
      <div class="basket-items">
        <div class="basket-items__container">
          <div class="basket-items__list">
            <div class="basket-panel">
              <div class="basket-panel__item basket-panel__item--all form-checkbox">
                <input class="form-checkbox__input" type="checkbox" id="basket-item-check-all" :checked="allChecked"
                       @change="checkAll">
                <label class="form-checkbox__label" for="basket-item-check-all">
                  <span class="form-checkbox__box"></span>
                  <span class="form-checkbox__value">{{loc.getMessage('SALE_BASKET_ALL_ITEM')}}</span>
                </label>
              </div>
              <div v-if="total.DISABLE_CHECKOUT === false" class="basket-panel__item basket-panel__item--delete active" @click="deleteChecked">
                {{loc.getMessage('SALE_BASKET_DELETE_ITEM')}}
              </div>
            </div>
            <table class="basket-list">
              <thead></thead>
              <tbody>
              <template v-for="item in items">
                <Item :item="item"/>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `
}
